// Destination to Unsplash cover image mapping
const destinationImages: Record<string, string> = {
  tokyo: "https://images.unsplash.com/photo-1503899036084-c55cdd92da26?q=80&w=1974",
  japan: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?q=80&w=2070",
  kyoto: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?q=80&w=2070",
  paris: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?q=80&w=2073",
  france: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?q=80&w=2073",
  bali: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?q=80&w=2038",
  indonesia: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?q=80&w=2038",
  barcelona: "https://images.unsplash.com/photo-1583422409516-2895a77efded?q=80&w=2070",
  spain: "https://images.unsplash.com/photo-1543783207-ec64e4d95325?q=80&w=2070",
  new_york: "https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?q=80&w=2070",
  london: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=2070",
  rome: "https://images.unsplash.com/photo-1552832230-c0197dd311b5?q=80&w=2070",
  italy: "https://images.unsplash.com/photo-1552832230-c0197dd311b5?q=80&w=2070",
  bangkok: "https://images.unsplash.com/photo-1508009603885-50cf7c579365?q=80&w=2070",
  thailand: "https://images.unsplash.com/photo-1508009603885-50cf7c579365?q=80&w=2070",
  lisbon: "https://images.unsplash.com/photo-1585208798174-6cedd86e019a?q=80&w=2073",
  portugal: "https://images.unsplash.com/photo-1585208798174-6cedd86e019a?q=80&w=2073",
  amsterdam: "https://images.unsplash.com/photo-1534351590666-13e3e96b5017?q=80&w=2070",
  berlin: "https://images.unsplash.com/photo-1560969184-10fe8719e047?q=80&w=2070",
  greece: "https://images.unsplash.com/photo-1570077188670-e3a8d3c755d8?q=80&w=2069",
  santorini: "https://images.unsplash.com/photo-1570077188670-e3a8d3c755d8?q=80&w=2069",
  dubai: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=2070",
  sydney: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?q=80&w=2070",
  australia: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?q=80&w=2070",
  mexico: "https://images.unsplash.com/photo-1518638150340-f706e86654de?q=80&w=2073",
  iceland: "https://images.unsplash.com/photo-1504829857797-ddff29c27927?q=80&w=2070",
  vietnam: "https://images.unsplash.com/photo-1583417319070-4a69db38a482?q=80&w=2070",
  morocco: "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?q=80&w=2067",
};

const defaultImage = "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?q=80&w=2070";

export function getCoverImage(destination: string): string {
  const lower = destination.toLowerCase();
  for (const [key, url] of Object.entries(destinationImages)) {
    if (lower.includes(key)) return url;
  }
  return defaultImage;
}

/**
 * Capitalizes destination strings: "bangkok" -> "Bangkok", "ho chi minh city" -> "Ho Chi Minh City",
 * "paris, france" -> "Paris, France". Preserves punctuation and existing capitalization in
 * already-capitalized words.
 */
export function capitalizeDestination(destination: string): string {
  if (!destination) return destination;
  return destination
    .split(/(\s+|,)/)
    .map((part) => {
      if (/^\s+$/.test(part) || part === ",") return part;
      // Don't recapitalize words that are already mixed case (e.g. "McDonald's", "NYC")
      if (/[A-Z]/.test(part) && /[a-z]/.test(part)) return part;
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    })
    .join("");
}
